module.exports = __webpack_public_path__ + "img/icon_audio_started.dd182c03.gif";